export default __webpack_public_path__ + "static/media/selecao.02636f0d.webp";